// extracted by mini-css-extract-plugin
module.exports = {"headerColumn":"style_headerColumn__fWDN9mKK0Lk-duyLH_rRH","rowColumn":"style_rowColumn__1K7DsNA32Ym9ps9JwMdnfZ","feedName":"style_feedName__2s8cj5nIO23M47-vimOiiA"};